import React from "react";
import Pagination from "react-js-pagination";

const PaginationSection = ({ iTotal, dataSearch, handlePageChange }) => (
  <div className="row">
    <div className="col-sm-12 col-md-6">
      <span className="color7">
        {iTotal === 0 ? (
          "Hiển thị 0 - 0 / Tổng số 0"
        ) : (
          <>
            Hiển thị{" "}
            {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
            {Math.min(
              dataSearch.pageIndex * dataSearch.pageSize,
              iTotal
            )}{" "}
            / Tổng số {iTotal}
          </>
        )}
      </span>
    </div>
    <div className="col-sm-12 col-md-6">
      <div
        className={
          "paniation-new paniation-new1 d-flex justify-content-center " +
          (iTotal === 0 ? "hidden" : "")
        }
        style={{ float: "right" }}
      >
        <nav aria-label="Page navigation">
          <Pagination
            activePage={dataSearch.pageIndex}
            itemsCountPerPage={dataSearch.pageSize}
            totalItemsCount={iTotal}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item border-none"
            linkClass="page-link border-none"
            activeClass="active"
          />
        </nav>
      </div>
    </div>
  </div>
);

export default PaginationSection;